// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GxfG1","name":"Header_name__1hMuv","birthday":"Header_birthday__26HSA","skeleton":"Header_skeleton__3Ktzf"};